if (!customElements.get('product-image-slider')) {
  class ProductImageSlider extends HTMLElement {
    connectedCallback() {
      this.currentSlide = parseInt(this.dataset.initialSlide || '0', 10);
      this.slides = this.querySelectorAll('.card-product-slider__slide');
      this.dots = this.querySelectorAll('.card-product-slider__dot');

      if (this.slides.length <= 1) return;

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.goToSlide(index);
        });
      });

      // Touch support
      this._touchStartX = 0;
      this.addEventListener('touchstart', (e) => {
        this._touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const diff = this._touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 30) {
          if (diff > 0) {
            this.goToSlide((this.currentSlide + 1) % this.slides.length);
          } else {
            this.goToSlide((this.currentSlide - 1 + this.slides.length) % this.slides.length);
          }
        }
      }, { passive: true });

      // Mouse drag support
      this._mouseStartX = 0;
      this._mouseDidDrag = false;
      this.addEventListener('mousedown', (e) => {
        this._mouseStartX = e.clientX;
        this._mouseDidDrag = false;
        
        const onMouseMove = (moveEvent) => {
          if (!(moveEvent.buttons & 1)) {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            return;
          }
          if (Math.abs(moveEvent.clientX - this._mouseStartX) > 8) {
            this._mouseDidDrag = true;
          }
        };
        
        const onMouseUp = (upEvent) => {
          document.removeEventListener('mousemove', onMouseMove);
          document.removeEventListener('mouseup', onMouseUp);
          
          if (!this._mouseDidDrag) return;
          const diff = this._mouseStartX - upEvent.clientX;
          if (diff > 30) {
            this.goToSlide((this.currentSlide + 1) % this.slides.length);
          } else if (diff < -30) {
            this.goToSlide((this.currentSlide - 1 + this.slides.length) % this.slides.length);
          }
        };
        
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });
      
      // Prevent browser default image drag behavior
      this.querySelectorAll('.card-product-slider__slide').forEach(slide => {
        slide.addEventListener('dragstart', (e) => {
          e.preventDefault();
        });
      });
      
      // Prevent link navigation when dragging
      this.addEventListener('click', (e) => {
        if (this._mouseDidDrag) {
          e.preventDefault();
          e.stopPropagation();
          this._mouseDidDrag = false;
        }
      }, true);

      // Trackpad / mouse wheel horizontal scroll support
      this._wheelCooldown = false;
      this.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // ignore vertical scroll
        e.preventDefault();
        if (this._wheelCooldown) return;
        if (e.deltaX > 5) {
          this._wheelCooldown = true;
          this.goToSlide((this.currentSlide + 1) % this.slides.length);
          setTimeout(() => { this._wheelCooldown = false; }, 600);
        } else if (e.deltaX < -5) {
          this._wheelCooldown = true;
          this.goToSlide((this.currentSlide - 1 + this.slides.length) % this.slides.length);
          setTimeout(() => { this._wheelCooldown = false; }, 600);
        }
      }, { passive: false });
    }

    goToSlide(index) {
      this.slides[this.currentSlide].classList.remove('is-active');
      if (this.dots[this.currentSlide]) {
        this.dots[this.currentSlide].classList.remove('is-active');
        this.dots[this.currentSlide].setAttribute('aria-selected', 'false');
      }

      this.currentSlide = index;

      this.slides[this.currentSlide].classList.add('is-active');
      if (this.dots[this.currentSlide]) {
        this.dots[this.currentSlide].classList.add('is-active');
        this.dots[this.currentSlide].setAttribute('aria-selected', 'true');
      }
    }
  }

  customElements.define('product-image-slider', ProductImageSlider);
}
